var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    staticClass: "p-relative d-flex flex-column secondary ma-1",
    attrs: {
      "height": _vm.$vuetify.breakpoint.xs ? 'auto' : '100%',
      "max-width": "600px",
      "min-width": "400px",
      "rounded": "lg",
      "min-height": "100%",
      "width": "100%"
    }
  }, 'v-card', Object.assign({}, _vm.cardDefaults, _vm.cardProps), false), [_vm.imageSrc ? _c('v-img', _vm._b({
    attrs: {
      "src": _vm.imageSrc,
      "cover": "",
      "height": _vm.imgHeight,
      "max-height": _vm.imgHeight,
      "width": "100%"
    }
  }, 'v-img', Object.assign({}, _vm.imgProps), false)) : _vm._e(), _vm.titleText ? _c('v-card-title', _vm._b({
    staticClass: "text-h5 text-sm-h4 font-weight-bold justify-center break-word",
    domProps: {
      "innerHTML": _vm._s(_vm.titleText)
    }
  }, 'v-card-title', Object.assign({}, _vm.titleDefaults, _vm.cardTitleProps), false)) : _vm._e(), _c('v-card-text', _vm._b({
    staticClass: "flex-grow-1"
  }, 'v-card-text', Object.assign({}, _vm.cardTextProps), false), [_vm._t("card-text")], 2), _c('v-card-actions', _vm._b({}, 'v-card-actions', _vm.cardActionsProps, false), [_vm._t("card-actions")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }